import React from 'react';
import { useField } from 'formik';

import FileSlide from './FileSlide.jsx';

const FieldFileSlide = (props) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  return (
    <FileSlide
      {...props}
      value={value}
      onChange={(v) => {
        setValue(v);
        setTouched();
      }}
    />
  );
};

export default FieldFileSlide;
